<template>
  <!-- eslint-disable -->
  <div class="text-md">
    <h1 class="h1 text-bold text-uppercase p-b-3 m-0">
      Pro Referral Privacy Policy
    </h1>

    <p>
      This Privacy Policy describes the privacy practices of Red Beacon, Inc. and its subsidiaries, divisions, affiliates, and brands ("Pro Referral", "we" or "us") in association with offering the Pro Referral services. Pro Referral is powered by The Home Depot.  
    </p>
    <p>
      It applies to the information we collect in association with your interactions with us, including, but not limited to:
    </p>
    <ul class=" p-b-1">
        <li>Uses of our websites, including <a href="ProReferral.com">ProReferral.com</a> and any mobile websites</li>
        <li>Use of our applications for mobile phones, tablets, or other smart devices</li>
        <li>Phone and email communications with us</li>
        <li>Viewing our online advertisements or emails</li>
        <li>Interactions with authorized service providers</li>
    </ul>

    <p>
      It also applies to personal information that we receive from business partners and other companies. You can find out more information about our collection of personal information below.
    </p>
    <p>
      Activities that are subject to this Privacy Policy are also subject to our Terms of Service.
    </p>
    <p>
      For the purpose of this Privacy Policy only, a “Pro” is defined as any entity or person that seeks work using the referral services provided by Pro Referral, including contractors and consultants of registered Pros that may or may not have a contractual relationship with Pro Referral. 
    </p>

    <p>
      If you have any questions or comments about this Privacy Policy or our use of your personal information, please contact us at <a href="mailto:support@ProReferral.com">support@ProReferral.com</a>.
    </p>

    <section>
      <AboutSectionHeading>
        WHAT DO WE COLLECT?
      </AboutSectionHeading>
      <p>
        We collect personal information when you visit or interact with our applications. 
      </p>
      <p class="text-lg text-bold">Identifiers</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Information such as:
      </p>
    <ul class=" p-b-1">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Username</li>
        <li>Device identifier</li>
        <li>IP address</li>
        <li>Account login credentials</li>
      </ul>

      <p>
        Additional information collected for Pros:
      </p>
      <ul class=" p-b-1">
        <li>Physical address</li>
        <li>Government-issued identification number</li>
        <li>Date of birth/age</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul class=" p-b-1">
        <li>Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.</li>
        <li>Security and fraud prevention services that help us confirm that transactions are valid and otherwise help us protect our assets and you.</li>
        <li>Marketing companies that help us learn about our customers and Pros, and the devices they use to access digital content.</li>
        <li>Companies that supplement our customer and Pro records with additional information.</li>
        <li>Advertising companies and content publishers that present you with our ads.</li>
        <li>Communications and mailing vendors.</li>
        <li>Our Affiliates and subsidiaries.</li>
      </ul>

      <p>
        Additional information collected for Customers:
      </p>
      <ul>
        <li>Other customers that may provide us with your information to recommend a product or service, or list you as a recipient of products or services.</li>
      </ul>

      <p>
        Additional information collected for Pros:
      </p>
      <ul>
        <li>Other Pros that may provide us with your information to recommend you for Pro Referral.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Providing the applications and Pro Referral services.</li>
        <li>Providing support.</li>
        <li>Communicating with you.</li>
        <li>Administering contests and promotions.</li>
        <li>Registering you on the applications.</li>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Identifying the devices you use to access digital content.</li>
        <li>Fraud prevention and security.</li> 
      </ul>

      <p>
        Additional reasons why we collect and disclose for Pros:
      </p>
      <ul>
        <li>Performing background checks.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Customers seeking Pros or Pros seeking job and project opportunities.</li>
        <li>Service providers that process information on our behalf, such as providers of digital analytics services, software services and support, security, and fraud prevention services.</li>
        <li>Joint marketing partners.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p>
        Additional information disclosed for Pros:<br>
        Service providers that process information on our behalf, such as background check services.
      </p>
      <p class="text-lg text-bold">Internet Activity</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Activity such as:
      </p>
      <ul class=" p-b-1">
        <li>Information about your interactions with our applications and advertisements.</li>
        <li>Your interactions with our website and applications, which may be recorded and replayed using session replay software.</li>
        <li>Browsing history</li>
        <li>Search history</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Directly from you or the devices you use to access our website and applications.</li>
        <li>Marketing companies that help us learn about our customers and the devices they use to access digital content.</li>
        <li>Companies that supplement our customer records with additional information.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Providing the applications and Pro Referral services.</li>
        <li>Providing support.</li>
        <li>Communicating with you.</li>
        <li>Administering contests and promotions.</li>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Identifying the devices you use to access digital content.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Service providers that process information on our behalf, such as for digital analytics services, software services and support, security, and fraud prevention services.</li>
        <li>Joint marketing partners.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Our affiliates and subsidiaries.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
      </ul>

      <p class="text-lg text-bold">Commercial Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Information such as:
      </p>
      <ul>
        <li>Projects and jobs requested</li>
        <li>Reviews you submit</li>
        <li>Offers and quotes made</li>
        <li>Services purchased.</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Directly from you or the devices you use to access digital services, such as websites, mobile applications, and applications for connected devices.</li>
        <li>Marketing companies that help us learn about our customers and the devices they use to access digital content.</li>
        <li>Companies that supplement our customer records with additional information.</li>
        <li>Advertising companies and content publishers that present you with our ads.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Providing the applications and Pro Referral services.</li>
        <li>Providing support.</li>
        <li>Communicating with you.</li>
        <li>Administering contests and promotions.</li>
        <li>Registering you on the applications.</li>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Identifying the devices you use to access digital content.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Customers seeking Pros or Pros seeking opportunities. </li>
        <li>Service providers that process information on our behalf, such as for software services and support, and data storage providers. </li>
        <li>Joint marketing partners.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p class="text-lg text-bold">Demographic Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Information such as:
      </p>
      <ul>
        <li>Age</li>
        <li>Gender</li>
        <li>Race</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Directly from you.</li>
        <li>Companies that provide services on our behalf, such as customer satisfaction surveys.</li>
        <li>Marketing companies that help us learn about our customers and the devices they use to access digital content.</li>
        <li>Companies that supplement our customer records with additional information.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Service providers that process information on our behalf, such as for customer satisfaction surveys, software services and support.</li>
        <li>Joint marketing partners.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners. </li>
        <li>Any successor to all or part of our business.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>
      
      <p>
        Additional disclosures for Pros:
      </p>
      <ul>
        <li>Service providers performing services on our behalf, such as for background checks, security, or fraud prevention services.</li>
      </ul>

      <p class="text-lg text-bold">Location Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Location based on:
      </p>
      <ul>
        <li>IP address location information.</li>
        <li>Mobile device location information.</li>
      </ul>
      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Directly from you or the devices you use to access our website or applications.</li>
        <li>Security and fraud prevention services that help us protect our assets and you.</li>
        <li>Marketing companies that help us learn about our customers and the devices they use to access digital content.</li>
        <li>Companies that supplement our customer records with additional information.</li>
        
      </ul>
      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Providing support.</li>
        <li>Communicating with you.</li>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Identifying the devices you use to access digital content.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Service providers that process information on our behalf, such as for software services and support.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners.</li>
        <li>Joint marketing partners.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries. </li>
      </ul>

      <p class="text-lg text-bold">Employment Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        For Pros, information such as:
      </p>
      <ul>
        <li>Profession</li>
        <li>Trade</li>
        <li>Skills</li>
        <li>Line of Business</li>
        <li>Certifications</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Directly from you.</li>
        <li>Companies that provide information to us at our request, such as for background check services.</li>
        <li>From other Pros that refer you to our services. </li>
        <li>Companies that supplement our Pro Referral Pro records with additional information.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Providing the applications and Pro Referral services.</li>
        <li>Registering you on the applications.</li>
        <li>Communicating with you.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Customers seeking Pros. </li>
        <li>Service providers that process information on our behalf, such as for background checks, security, or fraud prevention services. </li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners. </li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p class="text-lg text-bold">Business Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        For Pros, information such as:
      </p>
      <ul>
        <li>Business name</li>
        <li>Business insurance</li>
        <li>Business license</li>
        <li>Other business characteristics</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Directly from you.</li>
        <li>Companies that provide information to us at our request, such as for background check services.</li>
        <li>From other Pros that refer you to our services. </li>
        <li>Companies that supplement our Pro Referral Pro records with additional information.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Providing the applications and Pro Referral services.</li>
        <li>Registering you on the applications.</li>
        <li>Communicating with you.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Fraud prevention and security.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <p>
        For Pros:
      </p>
      <ul>
        <li>Customers seeking Pros. </li>
        <li>Service providers that process information on our behalf, such as for background checks, security, or fraud prevention services.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners. </li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p class="text-lg text-bold">Audio Recordings</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Activity such as: 
      </p>
      <ul>
        <li>Customer care calls and software-based customer care analysis.</li>
        <li>To operate and improve our business.</li>
        <li>Monitoring use of technology in compliance with our policies and practices.</li>
        <li>Complying with laws and regulations, and cooperating with law enforcement related to enforcement of laws and regulations.</li>
        <li>Training</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Via call recordings.</li>
      </ul>
      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Improving our products and services, including digital content.</li>
        <li>Providing support.</li>
        <li>Learning about trends and interests.</li>
        <li>Fraud prevention and security.</li>
        <li>Training.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Service providers that process information on our behalf, such as software services and support, data storage providers, and fraud prevention services. </li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p class="text-lg text-bold">Inferences</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <p>
        Information such as:
      </p>
      <ul>
        <li>Preferences</li>
        <li>Interests</li>
        <li>Other Characteristics</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>Directly from you.</li>
        <li>Companies that supplement our customer records with additional information.</li>
        <li>Companies that provide services on our behalf, such as customer service surveys and others that communicate with you about projects.</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>Communicating with you.</li>
        <li>Providing support.</li>
        <li>Improving our products and services, including digital content.</li>
        <li>Learning about trends and interests.</li>
        <li>Personalizing digital content.</li>
        <li>Delivering marketing communications and advertising.</li>
        <li>Identifying the devices you use to access digital content.</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>Service providers performing services on our behalf, such as for software services and support, and data storage providers.</li>
        <li>Joint marketing partners.</li>
        <li>Any successor to all or part of our business.</li>
        <li>Advisors and consultants.</li>
        <li>Advertising partners. </li>
        <li>Law enforcement, public and government authorities, and other entities as we deem reasonably necessary to comply with law, support investigations, and protect the rights and property of you, us, and others.</li>
        <li>Our affiliates and subsidiaries.</li>
      </ul>

      <p class="text-lg text-bold">Information that May Be Considered Sensitive Personal Information</p>
      <p>
        <span class="text-underline">What information does this include?</span>
      </p>
      <ul>
        <li>Account login credentials.</li>
        <li>Race</li>
      </ul>

      <p>
        <span class="text-underline">Where do we collect it from?</span>
      </p>
      <ul>
        <li>See relevant disclosures above regarding Identifiers (for account login credentials).</li>
        <li>See relevant disclosures above regarding Demographics (for race).</li>
      </ul>

      <p>
        <span class="text-underline">Why do we collect and disclose it?</span>
      </p>
      <ul>
        <li>See relevant disclosures above regarding Identifiers (for account login credentials).</li>
        <li>See relevant disclosures above regarding Demographics (for race).</li>
      </ul>

      <p>
        <span class="text-underline">Who do we disclose it to?</span>
      </p>
      <ul>
        <li>See relevant disclosures above regarding Identifiers (for account login credentials).</li>
        <li>See relevant disclosures above regarding Demographics (for race).</li>
      </ul>

      <p>We do not sell or share personal information, including personal information of individuals under 18.</p>
      <p>We retain the personal information we collect for as long as reasonably necessary to fulfill the purposes described above or when the information was collected, unless a shorter retention period is required by law. We may retain personal information after our relationship with you ends. The length of retention may vary depending upon factors such as:</p>

      <ul>
        <li>Recordkeeping or legal compliance requirements;</li> 
        <li>The need to resolve inquiries or complaints;</li> 
        <li>Operating, expanding, and improving our business;</li> 
        <li>The need to exercise or defend legal claims;</li>
        <li>The need to prevent fraud, protect assets, and promote security; and</li>
        <li>Protecting the rights or safety or you, us, or others.</li>
      </ul>
    </section>

    <section>
      <AboutSectionHeading>
        HOW DO WE COLLECT PERSONAL INFORMATION?
      </AboutSectionHeading>
      <p>
        We collect personal information directly from you. 
      </p>
      <p>
        For example, we collect personal information when you:
      </p>
      <ul>
        <li>use the website or applications;</li>
        <li>register on the applications;</li>
        <li>create a Skill Profile; or</li>
        <li>participate in surveys.</li>
      </ul>

      <p>
        <span class="text-underline">Information Collected Upon Visiting.</span> When you visit our websites or applications, our servers automatically record information that your browser sends whenever you visit a website. This may include information such as your IP address, browser type or the domain from which you are visiting, the webpages you visit, the search terms you use, and any advertisements or links on which you click. For most users accessing the Internet from an Internet service provider the IP address will be different every time you log on. We use this information to monitor the use of the applications and of our Service, and for the applications’ technical administration.
      </p>

      <p>We use tools like browser cookies, pixel tags, and web beacons to collect information when you interact with our applications.
      </p>
      <p>
        <span class="text-underline">Information Collected Upon Registration.</span> If you desire to have access to certain restricted sections of the applications, you will be required to become a registered user, and to submit certain personal information to Pro Referral. This happens in a number of instances, such as when you sign up for the Pro Referral service, if you desire to receive marketing materials and information, if you submit a Service Request, and/or if you create a Skill Profile to offer services through Pro Referral. Information that we may collect in such instances may include your full name, password, email address, telephone number, mobile phone number for text messages, photographs you upload, and other information that you decide to provide us with, or that you decide to include in your public profile. If you register as a Pro or create a Skill Profile we will ask for additional information related to your business, including street address, and other personal information as noted in this Privacy Policy.
      </p>
      <p>
        <span class="text-underline">Skill Profile Information.</span> <br>
        If you create a Skill Profile, you have the opportunity to provide additional information (“Business Information”) such as your business name, logo or avatar, credentials and qualifications, year of business establishment, as well as links to your personal website, if you have one. You may also upload a photograph portfolio of your previous work. We may supplement or modify the Business Information to conform to our editorial policies or to add information from your website, materials that you supply to us, or publicly available sources. When you respond to a customer’s Service Request, all of the Business Information is displayed to the customer making such Service Request. Providing additional information beyond what is required at registration is entirely optional, but may enable you to market your services more effectively and potentially win more jobs on the applications. If you contact us by email through the applications, we may keep a record of your contact information and correspondence and use such information to respond to your inquiry. 
      </p>
      <p>
        <span class="text-underline">Survey.</span>
        We may also collect personal information if you participate in surveys conducted by or on behalf of us or our partner companies, including but not limited to questionnaires, telephone interviews and/or discussion groups, and otherwise providing general information about the Pro Referral service. 
      </p>
      <p>
        We may receive personal information from and disclose personal information with The Home Depot and companies that are controlled by or under common control with The Home Depot.
      </p>
      <p>
        We may collect personal information from a variety of unaffiliated companies. For example, we may collect information from:
      </p>
      <ul>
        <li>Other Pro Referral members and Pros.</li>
        <li>Marketing companies that help us learn about interests and trends.</li>
        <li>Marketing companies that help us learn about the devices our customers and Pros use to access digital content.</li>
        <li>Companies that supplement our customer and Pro records with additional information.</li>
        <li>Advertising companies and content publishers that present you with our ads.</li>
        <li>Communications and mailing vendors.</li>
        <li>Online analytics providers.</li>
        <li>Friends or associates (such as for a refer a friend program).</li>
        <li>Service providers that operate on our behalf and collect information.</li>
        <li>Security and fraud prevention providers.</li>
      </ul>

      <p>
        For Pros we may also collect information from the following additional unaffiliated companies:
      </p>
      <ul>
        <li>
          Background check providers.
        </li>
      </ul>
    </section>

    <section>
      <AboutSectionHeading>
        WHY DO WE COLLECT PERSONAL INFORMATION?
      </AboutSectionHeading>
      <p>
        As explained in detail above in the ‘WHAT DO WE COLLECT’ section, in general, we collect and use your data to:
      </p>
      <ul>
        <li>Provide the applications and Pro Referral services.</li>
        <li>Deliver the  services that you request.</li>
        <li>Communicate with you by email, postal mail, telephone, text message, and/or mobile devices or send newsletters about products or services that may be of interest to you.</li>
        <li>Communicate with you with regard to partially completed service requests or job offers.</li>
        <li>Register you on the applications.</li>
        <li>Manage your account and provide you with customer support.</li>
        <li>Perform research and analysis about your use of, or interest in, our products, services, or content, or products, services or content offered by others.</li>
        <li>Develop and display personalized digital content tailored to your interests on our website and other sites.</li>
        <li>Develop and deliver personalized marketing communications and advertising tailored to your interests.</li>
        <li>Improve our products and services, including digital content.</li>
        <li>Learn about trends and customer preferences.</li>
        <li>Identifying devices you use to access digital content.</li>
        <li>Create Anonymous Data records from such information.</li>
        <li>Administering contests and promotions.</li>
        <li>Fraud prevention and security.</li>
        <li>Support investigations and protect the rights and property of you, us, and others.</li>
        <li>Enforce our terms and conditions.</li>
        <li>Manage our business.</li>
        <li>Perform functions as otherwise described to you in this Privacy Policy or at the time of collection.</li>
      </ul>

      <p>
        For Pros we may also collect information and use it to:
      </p>
      <ul>
        <li>Determine eligibility for participation as a Pro in our Pro Referral program.</li>
        <li>Determine eligibility to provide services offered, such as meeting licensing requirements.</li>
        <li>Communicate business and skill information to customers.</li>
      </ul>

      <p>
        If you decide at any time that you no longer wish to receive direct marketing information or communications from us, please follow the unsubscribe instructions provided in any of the communications.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        PERSONAL INFORMATION DISCLOSURE
      </AboutSectionHeading>
      <p>
        We may disclose your personal information for our business purposes and when permitted or required by law. Please see below for examples of circumstances in which we disclose information. We do not disclose or share your personal information with others except as indicated below, as directed by you, or when we inform you and give you an opportunity to opt out of having your personal information shared. Under no circumstances, other than as described herein, will Pro Referral transfer names and contact information ("Customer Lists") to an unaffiliated third party for the third party's own use.
      </p>
      <p>
        Circumstance under which we may disclose your personal information:
      </p>
      <p>
        <span class="text-underline">To Provide Information to Pros.</span>
        We may disclose your personal information with Pros. The information we disclose is generally the information contained in the Service Request form, including the username (and first name of the customer when we have it), email address, phone number, the type of service needed, when and the zip code where the service should be performed, a description of the service needed, and any photographs you provide pertaining to the Service Request. 
      </p>
      <p>
        <span class="text-underline">To Provide Information to Customers.</span>
        If you are a registered Pro, we may disclose your and your contractors’ and consultants’ personal information with Customers requesting services through Pro Referral. Sharing this information with Customers helps them to assess Pro quality and select the Pro to perform the service they need done. The information we disclose is generally the information in your Skill Profile, with the exception of your address, contact phone number, mobile phone number, and email address. In addition, we disclose any additional information you choose to provide to the Customer such as appointment start times, private notes, and questions about the Service Request. If you are selected by the Customer, Pro Referral will then, and only then, disclose your address, contact phone number, and email address with the Customer in order to facilitate communication about the scheduled job.
      </p>
      <p>
        <span class="text-underline">To Provide Information to Partner Companies.</span>
        We may enter into agreements with one or more partner companies pursuant to which we provide a partner company with a URL and a user registration page co-branded with, or private labeled by, the partner company, and the partner company distributes and promotes the URL to its customers. A partner company may want to access personal information that we collect from its customers. As a result, if you register on our website or other application through a partner company, or if you are directed to or access our website, or other application or their features (such as but not limited to an embedded widget) through a partner company, we may provide your personal information to the partner company. Because we do not control the privacy practices of our partner companies, you should read and understand their privacy policies.
      </p>
      <p>
        <span class="text-underline">To Facilitate Pro Referral’s Use of Service Providers.</span>
        We engage certain trusted service providers to perform functions and provide services to us, including, without limitation, software services and support, data storage and management, joint marketing efforts, customer satisfaction surveys, advertising, advisory and consulting services, background checks, security services, and fraud prevention services. 
      </p>
      <p>
        For Pros, in addition to above, we will disclose your personal information to background check providers.
      </p>
      <p>
        <span class="text-underline">To Comply with Laws and Law Enforcement.</span>
        We may disclose any personal information about you to law enforcement, public, and government authorities, and other entities as we deem reasonably necessary to comply with the law, support investigations, and protect the rights and property of you, us, and others. For example, we will disclose information to respond to a court order or subpoena. We may also disclose information if a government agency or investigatory body requests it.
      </p>
       <p>
        <span class="text-underline">In Connection with Business Transfers.</span> Pro Referral may sell, transfer or otherwise disclose some or all of its assets, including your personal information, in connection with a merger, acquisition, reorganization or sale of assets or in the event of bankruptcy. You will have the opportunity to opt out of any such transfer if the new entity's planned processing of your personal information differs materially from that set forth in this Privacy Policy.
      </p>
      <p>
        <span class="text-underline">To Provide Information to Pro Referral Affiliates.</span>
        We may disclose your personal information with a company controlled by, or under common control with, Pro Referral for any purpose permitted by this Privacy Policy.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        CHANGING OR DELETING ACCOUNT INFORMATION
      </AboutSectionHeading>
      <p>
        If you are a registered user of an application, you may access and update or correct the information you provided to us by updating your settings in your account and /or your Skill Profile in Manage Profiles. If you wish to delete your account, you must email <a href="mailto:support@ProReferral.com">support@ProReferral.com</a> with your request.
      </p>
      <p>
        See the section below entitled Your State Privacy Rights for more information about deleting your personal information. 
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        Security
      </AboutSectionHeading>
      <p>
        While we use industry standard means to protect our websites and your information, the Internet is not 100% secure. The measures we use are appropriate for the type of information we collect. We cannot promise that your use of our websites or mobile applications will be completely safe. We encourage you to use caution when using the Internet. Online access to your personal information is protected with a password you select. We strongly recommend that you do not share your password and that you use unique passwords for all of your online accounts.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        Links to other websites
      </AboutSectionHeading>
      <p>
        Our applications contain links to other websites. The fact that we link to a website is not an endorsement, authorization or representation of our affiliation with that third party. We do not exercise control over third party websites. These other websites may place their own cookies or other files on your computer, collect data or solicit personal information from you. Other sites follow different rules regarding the use or disclosure of the personal information you submit to them. We encourage you to read the privacy policies or statements of the other websites you visit.
      </p>
    </section>

    <section>
      <AboutSectionHeading>
        Children
      </AboutSectionHeading>
      <p>
        The applications are not directed to persons under 18. If a parent or guardian becomes aware that his or her child has provided us with personal information without the parent or guardian’s consent, he or she should contact us at <a href="mailto:support@ProReferral.com">support@ProReferral.com</a>. We do not knowingly collect personal information from minors under 18. If we become aware that a minor under 18 has provided us with personal information, we will use reasonable commercial efforts to promptly delete such information from our files.
      </p>
    </section>

    <section>
      <h2>YOUR STATE PRIVACY RIGHTS</h2>
      <p>
        Depending on the state in which you reside, you may have the following privacy rights, subject to statutory limitations: 
      </p>
      <ul>
        <li>Right to Know and Access: Consumers have a right to request information about the personal information that we collect, use, disclose, share, and sell, including requesting the specific pieces of personal information we have collected about them. Residents of Delaware, Minnesota, and Oregon also have the right to request a list of specific third parties to whom we disclose personal information.</li>        <li>Right to Delete: Consumers have a right to request the deletion of personal information that we have collected from them, though we may be permitted to retain personal information for certain purposes.</li>
        <li>Right to Correct:  Consumers have a right to request that we correct inaccurate personal information.  </li>
        <li>Right to Opt Out of Sales and Sharing or Using for Targeted Advertising: Pro Referral does not sell your personal information or disclose it for targeted advertising purposes. If you would like to exercise your right to opt out of the sale of your personal information while using HomeDepot.com, please click here: <a href="https://www.homedepot.com/c/Exercise_My_Privacy_Rights">Do Not Sell Or Share My Personal Information.</a> </li>
        <li>Right to Limit the Use of Sensitive Information:  Consumers have a right to request that we use and disclose certain sensitive information only for certain purposes permitted under law.  </li>
        <li>Right to Opt Out of Profiling that has legal or similarly significant effects. We do not profile individuals for purposes to which this right applies. </li>
        <li>Non-Discrimination: We may not discriminate against you for exercising your rights. We may, however, provide a different level of service or charge a different rate if the difference is reasonably related to the value of your information.</li>
      </ul>
      <p>
        If you would like to submit a request to exercise one of these rights, please visit our <a href="https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights">Privacy & Security Center - Submit Your Request</a> page or call us at <a href="tel:+18003941326">1-800-394-1326</a>. For help submitting a request online or via phone in one of our stores, please visit the customer service desk. Residents of states that offer the right to appeal may also contact us using these methods to appeal a decision we make relating to your rights request, subject to applicable law.
      </p>
      <p>
        For certain requests, we require that you provide the following information:
        <ul>
          <li>State of residence</li>
          <li>First and last name</li>
          <li>Email address and confirmation that the request is submitted by a natural person (for requests submitted online)</li>
          <li>Phone number (for requests submitted by phone)</li>
          <li>Postal address</li>
        </ul>

      </p>
      <p>
        For rights requiring identity verification, the information that you provide will be analyzed to determine whether we can reasonably verify your identity. We may need to obtain additional information from you to process your request. For example, if we determine that the information provided is not sufficient for verification, you may be prompted to answer a few questions.
      </p>
      <p>
        If you submit an email address with your access or delete request, we will send an email to you, asking that you confirm that we have the correct email address within six (6) days of receiving the confirmation email or your request will expire. If you do not see an email from us, please check your spam folder.
      </p>
      <p>
        There may be circumstances where we may not completely fulfill your request, as permitted under applicable law. For example, if you submit a request to delete your personal information, we may need to retain certain personal information to complete a job request, detect fraud, or comply with our legal obligations.
      </p>
      <p>
        If you are an authorized agent acting on behalf of a California resident, or acting on behalf of resident of a state with a similar legal requirement, please send your request to <a href="mailto:myinfo@homedepot.com">myinfo@homedepot.com</a> and include the following information about you and the person on whose behalf you are submitting the request: full name, mailing address, email address, and phone number. You should also provide proof of your authorization to act on the other person's behalf. We will contact you for additional information once your request has been received. Note that we may require the customer to verify their identity and confirm your authority as the agent.
      </p>
      <p>
        We have compiled information about the number of California privacy rights requests we received in the previous calendar year and how we responded to them. Please view the <a href="https://www.homedepot.com/privacy/California-Privacy-Rights-And-Report">California Privacy Rights &amp; Report</a> to view the report.
      </p>
      <p>
        Please read the section below entitled “Cookies” for information about how to control certain digital tracking tools and targeted internet advertising. </p>
    </section>
    
    <section>
      <AboutSectionHeading>
        COOKIES
      </AboutSectionHeading>
       <p>
        Like many websites, we also use "cookie" technology to collect additional website usage data and to improve the applications and our service. A cookie is a small data file that we transfer to your computer's hard disk. When you visit Pro Referral, we send one or more cookies - small file containing a string of characters - to your computer or other device that uniquely identifies your browser. Pro Referral may use cookies to better understand how you interact with the website and our service, to monitor aggregate usage by our users and web traffic routing on the website, and to improve the website and our services. Most Internet browsers automatically accept cookies. You can instruct your browser by editing its options, to stop accepting cookies or to prompt you before accepting a cookie from the websites you visit.
      </p>
    </section>

    <section>
      <h2>CONTACT US</h2>
      <p>
        If you have additional questions, concerns, would like information about how customers or Pros with disabilities may access this Privacy Policy in an alternative format, or have questions about how to exercise your rights, you can call us at 1-800-466-3337 or email us at <a href="mailto:support@ProReferral.com">support@ProReferral.com</a>. You can write to us at: The Home Depot, Attention: Privacy Customer Care, 2455 Paces Ferry Road, Atlanta, GA 30339-4024.
      </p>
    <p>
        From time to time we may change our privacy policies. We will notify you of any material changes to our Privacy Policy by posting an updated copy on our website. Please check our website periodically for updates.
      </p>
      <p>
        Last revision date: May 13, 2026.<br>
        Previous effective date: July 10, 2024.
      </p>
    </section>

  </div>
</template>

<script>
import AboutSectionHeading from '../../../../AboutSectionHeading';

export default {
  name: 'privacy-policy',
  metaInfo: {
    title: 'Privacy Policy',
  },
  components: {
    AboutSectionHeading,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  ul {
    margin: 0 0 8px 0;
  }
  p {
    @include padding-bottom(1);
  }
  a {
    text-decoration: underline;
  }
</style>
